import { Copy } from "lucide-react";
import type { FC } from "react";

import { toastSuccess } from "@/components/molecules";
import { cn } from "@/lib/utils";
import { commonIconProps12 } from "@/utils/constants";

interface CopyButtonProps {
  textToCopy: string;
  className?: string;
  ariaLabel?: string;
}

const CopyButton: FC<CopyButtonProps> = ({
  textToCopy,
  className,
  ariaLabel = "Copy to clipboard",
}) => {
  const handleCopy = async () => {
    if (!textToCopy) return;

    try {
      await navigator.clipboard.writeText(textToCopy);
      toastSuccess("Copied to clipboard!");
    } catch (err) {
      console.error("Failed to copy!", err);
    }
  };

  return (
    <button
      type="button"
      onClick={handleCopy}
      aria-label={ariaLabel}
      className={cn(
        "cursor-pointer rounded-sm p-1.5 text-muted-foreground transition-colors hover:bg-yellow-200/30 hover:text-foreground [&>svg]:stroke-gray-500",
        className
      )}
    >
      <Copy {...commonIconProps12} />
    </button>
  );
};

export default CopyButton;
